import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../services/UserContext";
import { isPushSupported, registerServiceWorker } from "../services/pushNotifications";

export default function ProtectedRoute() {
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user || !isPushSupported()) {
      return;
    }

    registerServiceWorker().catch(() => {
      /* SW opcional hasta activar push */
    });
  }, [user]);

  // Si no hay usuario, redirigir a login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
